<template>
  <div class="head-line-detail">
    <iframe class="frame" id="myFrame" :src="src" :height="600" frameborder="0"></iframe>
  </div>
</template>

<script>
import swTracker from '@/mixins/tracker.js'
export default {
  name: "HeadLineDetail",
  mixins: [swTracker],
  components: {
  },
  data () {
    return {
      src: ''
    }
  },
  computed: {
  },
  mounted () {
    const myFrame = document.getElementById('myFrame')
    let content = myFrame.contentWindow || myFrame.contentDocument
    if (content.document) {
      content = content.document
    }
    content.body.style.minHeight = '600px'
    const headLineUrl = this.$route && this.$route.query && this.$route.query.headLineUrl
    this.src = headLineUrl
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
  .head-line-detail{
    width: 1180px;
    margin: 0 auto;
    .frame{
      width: 100%;
      min-height: 1000px;
    }
  }
</style>

